import { Injectable } from "@angular/core";
import { GLOBAL } from "./global.service";
import { HttpClient } from "@angular/common/http";
import { Department } from "../models/department";
import { ResponseDTO } from "../models/general/response";

@Injectable({ providedIn: "root" })
export class DepartmentService {
  public url = `${GLOBAL.url}departmentService`;

  constructor(private http: HttpClient) {}

  getDepartments() {
    return this.http.get<ResponseDTO<Department>>(`${this.url}/listSearch/`);
  }

  getDepartmentByResponse(res: ResponseDTO<Department>): Department[] {
    const departmentsChildren = res.rows
      .map((d) => {
        if (d.name.includes("--")) {
          return {
            ...d,
            children: [...res.rows.filter((c) => c.fatherId === d.id)],
          };
        } else return d;
      })
      .filter((d) => !d.name.includes("---"));
    return departmentsChildren
      .map((d) => {
        if (d.fatherId === 0) {
          return {
            ...d,
            children: [
              ...departmentsChildren.filter((c) => c.fatherId === d.id),
            ],
          };
        } else return d;
      })
      .filter((d) => !d.name.includes("--"));
  }
}
